import React, { useState, useEffect } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { Card, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls";
import { getAllReferralBonusAsync, updateReferralBonusAsync, updateReferralBonusStatusAsync } from "../redux/referralBonusApi";
import { ReferralBonusActions } from "../redux/referralBonusAction";
import ReferralBonusTable from "./referral_detail/referralBonusTable";
import AddReferralBonus from "./referral_detail/AddReferralBonus";

export function ReferralBonusCoins() {
  const [showReferralModal, setShowReferralModal] = useState(false);
  const [selectedReferral, setSelectedReferral] = useState({});

  const { isLoading, referralBonusList, refreshReferralBonus } = useSelector(
    (state) => state.referralBonusCoins,
    shallowEqual
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllReferralBonusAsync());
  }, [refreshReferralBonus, dispatch]);

  const onSelectReferral = async (referral) => {
    setSelectedReferral(referral);
    setShowReferralModal(true);
  };

  const onStatusChange = async (referral) => {
    const newStatus = !referral.isActive;
    dispatch(updateReferralBonusStatusAsync(referral._id, { isActive: newStatus }));
  };

  return (
    <>
      <Card>
        <CardHeader title="Referral Bonus Coins Management">
          <CardHeaderToolbar>
            <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
              {/* Only show create button if no referral bonus exists */}
              {(!referralBonusList || !referralBonusList.data || referralBonusList.data.length === 0) && (
                <div className="form-group mr-5 mb-1 mt-2">
                  <button className="btn_new btn-sm" type="button" onClick={() => onSelectReferral({})}>
                    Create Referral Bonus Coins
                  </button>
                </div>
              )}
            </div>
          </CardHeaderToolbar>
        </CardHeader>
        <ReferralBonusTable
          referralBonusList={referralBonusList}
          onSelectReferral={onSelectReferral}
          onStatusChange={onStatusChange}
          isLoading={isLoading}
        />
        <AddReferralBonus
          setShowReferralModal={setShowReferralModal}
          showReferralModal={showReferralModal}
          selectedReferral={selectedReferral}
          isLoading={isLoading}
        />
      </Card>
    </>
  );
} 